import { Injectable, HostListener } from "@angular/core";
import { Route } from "@angular/compiler/src/core";
import { Subject } from "rxjs";
import { RouterPreloader } from "@angular/router";

export enum RouteParam {
    PanelTab,
    SymbolType,
    ChartDisplayMode
}

export const DefaultParamsValue = [ "symbol", "forex", "wizard" ];

export interface ParamChangedEvent {
    param: RouteParam;
    oldValue: RouteParamValue;
    newValue: RouteParamValue;
}

export type RouteParamValue = string | undefined;

@Injectable( {
    providedIn: "root"
} )
export class RoutingService {
    static ROUTE_PREFIX = "/";
    static EMPTY_PARAM = "_";

    onParamChanged: Subject<ParamChangedEvent> = new Subject();

    protected lastParams: RouteParamValue[] = [];

    get route () {
        return location.pathname.replace( RoutingService.ROUTE_PREFIX, "" );
    }

    constructor () {
        this.init();
        ( window as any ).routingService = this;
    }

    protected init () {
        this.setLastParams();
        window.addEventListener( "popstate", this.onPopstate.bind( this ) );
    }

    protected onPopstate ( event: Event ) {
        this.detectChangesAndFireEvents();
    }

    getParams (): RouteParamValue[] {
        const params = this.route.split( "/" );
        params.splice( 0, 1 );
        return params.map( rp => ( rp == RoutingService.EMPTY_PARAM ? undefined : rp ) );
    }

    getRouteFromParams ( routeParts: RouteParamValue[] ) {
        const routePartsMapped = routeParts.map( ( rp: RouteParamValue, index: number ) =>
            rp == undefined || rp.length < 1 ? DefaultParamsValue[ index ] || RoutingService.EMPTY_PARAM : rp
        );
        return Array.from(
            routePartsMapped,
            ( rp: RouteParamValue, index: number ) => rp || DefaultParamsValue[ index ] || RoutingService.EMPTY_PARAM
        ).join( "/" );
    }

    getParam ( param: RouteParam ): string | undefined {
        const routeParts = this.getParams();
        if ( routeParts.length > param ) {
            const paramValue = routeParts[ param ];
            return paramValue == RoutingService.EMPTY_PARAM ? undefined : paramValue;
        }

        return undefined;
    }

    setParam ( param: RouteParam, value: RouteParamValue ): RouteParamValue {
        const params = this.getParams();
        const oldValue = params[ param ];
        if ( oldValue == value ) return value;
        params[ param ] = value;
        this.setParams( params );
        return value;
    }

    setParams ( params: RouteParamValue[] ) {
        //  history.pushState("", "", RoutingService.ROUTE_PREFIX + "/" + this.getRouteFromParams(params));
        // this.detectChangesAndFireEvents(params);
    }

    protected fireParamChangedEvent ( param: RouteParam, oldValue: RouteParamValue, newValue: RouteParamValue ) {
        this.onParamChanged.next( { param: param, oldValue: oldValue, newValue: newValue } );
    }

    protected detectChangesAndFireEvents ( params?: RouteParamValue[] ) {
        if ( params == undefined ) params = this.getParams();
        const length = Math.max( params.length, this.lastParams.length );
        for ( let i = 0; i < length; i++ ) {
            const newValue = params[ i ];
            const oldValue = this.lastParams[ i ];
            if ( newValue != oldValue ) this.fireParamChangedEvent( i as RouteParam, oldValue, newValue );
        }
        this.setLastParams( params );
    }

    protected setLastParams ( params?: RouteParamValue[] ) {
        this.lastParams = ( params || this.getParams() ).slice();
    }
}
